import LapgraphImage from "../svg/Lapgraphimage.svg"
const SS = () => {
    return (
   
  <img src={LapgraphImage} />


    )
  }
  export default SS;